/**
 * plugins/webVitals.js
 *
 * Core Web Vitals reporting. In dev, logs to console. In prod, sends to
 * Clarity (already initialised) via custom event so we don't add yet
 * another telemetry endpoint in Sprint 0.
 */
import {
  onCLS, onINP, onLCP, onFCP, onTTFB,
} from 'web-vitals';

function report(metric) {
  if (import.meta.env.DEV) {
    // eslint-disable-next-line no-console
    console.log(`[WebVitals] ${metric.name}:`, metric.value, metric);
    return;
  }
  if (window.clarity) {
    window.clarity('event', `webvital:${metric.name}`, {
      value: metric.value,
      rating: metric.rating,
    });
  }
}

export function reportWebVitals() {
  onCLS(report);
  onINP(report);
  onLCP(report);
  onFCP(report);
  onTTFB(report);
}
